import PropTypes from 'prop-types';
var tabPropTypes = {
  content: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.node.isRequired
};
export var tabsPropTypes = {
  appearance: PropTypes.oneOf(['dropShadow', 'outlined']),
  className: PropTypes.string,
  controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  keepMounted: PropTypes.bool,
  mode: PropTypes.oneOf(['contained', 'extended']),
  onChangeTab: PropTypes.func,
  selectedTabId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tabs: PropTypes.arrayOf(PropTypes.shape(tabPropTypes).isRequired).isRequired,
  type: PropTypes.oneOf(['attached', 'online'])
};